module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAR0lEQVQ4T2NkwANSUlIcQNJz5sw5gEsZ46gBDIMgDEBRxcjI+B9HbBhAxS/gjEZYXGNTwMTEBDbg379/uA0YTQeDIR1QGgsASblA6wZ2o+EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/add.png
// module id = Zarb
// module chunks = 1